

export class LogSiteValidationWatch {
   public siteValidationWatchId: number = 0;
   public watcherUserId: number = 0;
   public siteId: number = 0;
   public tenantId: number = 0;
}